module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Chart-pie-93bdefac7afd23682bc7ad318e8b35bc.svg";